import { Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'
import strips from '../../media/strips.svg'
import chairSun from '../../media/chair-sun.svg'

import useBenefit from '../../hooks/useBenefit'
import useDefaultLeftRight from '../../hooks/useDefaultLeftRight'
import { SERVICES } from '../../constants'
import chairIcon from '../../media/chair_green_icon.svg'

// function srcset(image, width, height, rows = 1, cols = 1) {
// 	return {
// 		src: `${image}?w=${width * cols}&h=${height * rows}&fit=crop&auto=format`,
// 		srcSet: `${image}?w=${width * cols}&h=${height * rows}&fit=crop&auto=format&dpr=2 2x`,
// 	}
// }

const Benefit = () => {
	const { isLoading, title, content } = useBenefit()
	const { data: prestations } = useDefaultLeftRight(SERVICES.PRESTATION)

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<>
					{prestations && (
						<BodyHeader title={title} list={prestations}>
							{content}
						</BodyHeader>
					)}
				</>
			)}

			{prestations &&
				prestations.map(({ id, type, slug, title, content }, index) => (
					<Zone color={(index % 2 === 0 && 'white') || 'ivory'} key={id} id={slug}>
						<TitleSubtitle title={type} subtitle={title} />
						<Typography
							sx={(theme) => ({
								color: 'text.primary',
								textAlign: 'left',
								fontSize: 18,
								mt: 4,
								display: 'flex',
								width: '100%',
								flexFlow: (index % 2 === 1 && 'row-reverse wrap') || 'row wrap',
								fontFamily: 'montserrat',
								justifyContent: 'space-between',

								px: 2,

								[theme.breakpoints.down('md')]: {
									mt: 2,
								},

								'& figure': {
									pt: 4,
									m: 0,
									display: 'flex',
									justifyContent: (index % 2 === 0 && 'flex-start') || 'flex-end',

									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										pt: 0,
										flexBasis: '100%',
									},

									height: 'auto!important',

									position: 'relative',
									'& figure': { overflow: 'hidden', position: 'relative', bottom: '0' },

									'& img': {
										display: 'block',
										overflow: 'hidden',
										borderRadius: '8px',
										height: 'fit-content!important',
										width: '100%!important',

										[theme.breakpoints.down('md')]: {
											width: '100%',
											height: 'auto!important',
										},
									},
								},
								'& em': {
									fontSize: 16,
								},

								'& a': {
									color: 'secondary.main',
									fontWeight: 'bold',
								},

								'& h2': {
									fontSize: 22,
									fontWeight: 800,
									color: 'text.primary',
									mb: 2,
									background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
									pl: 4.5,
									display: 'table',
									[theme.breakpoints.down('md')]: {
										fontSize: 19,
										backgroundPositionY: 6,
										backgroundSize: 15,
										pl: 3,
										fontWeight: 900,
									},
								},
								'& pre': {
									borderLeft: `4px solid ${theme.palette.secondary.main}`,
									fontWeight: 700,
									fontFamily: 'montserrat',
									[theme.breakpoints.up('md')]: {
										p: theme.spacing(0, 0, 0, 2),
									},
									'& .MuiTypography-root': {
										[theme.breakpoints.down('md')]: {
											fontSize: 16,
										},
									},
								},
								'& blockquote': {
									m: 0,
									my: 2,
									fontSize: 22,
									'& p': {
										fontWeight: 'bold',
										mb: 0,
									},

									'& cite': {
										fontSize: 16,
										fontWeight: 400,
										position: 'relative',
										fontStyle: 'normal',
										textAlign: 'right',
										display: 'block',
									},
								},

								'& .wp-block-group': {
									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										flexBasis: '100%',
									},
								},

								'& .wp-block-button__link': {
									fontFamily: 'museomoderno',
									cursor: 'pointer',
									position: 'relative',
									display: 'table!important',
									borderRadius: '28px',
									fontSize: 16,
									p: theme.spacing(1, 2),
									bgcolor: 'secondary.main',
									color: 'white',
									fontWeight: 700,
									my: theme.spacing(2),
									minWidth: 169,
									textDecoration: 'none',
									border: `3px solid ${theme.palette.secondary.main}`,

									'&:hover': {
										bgcolor: 'secondary.main',
										border: `3px solid ${theme.palette.secondary.main}`,
									},

									[theme.breakpoints.down('md')]: {
										display: 'flex',
										m: theme.spacing(0, 'auto'),
										mt: 10,

										'& a': {
											display: 'flex',
											p: 3,
											border: 'none',
										},
									},
								},

								'& .wp-block-gallery': {
									display: 'flex',
									flexWrap: 'wrap',
									flexBasis: '100%',

									'& .wp-block-image': {
										position: 'relative',
										height: 'fit-content',
										flex: '1 1 400px',
										flexGrow: 1,
										m: 0.5,

										'& figcaption': {
											display: 'bloc',
											position: 'absolute',
											bottom: 0,
											left: 0,
											right: 0,
											background: 'rgba(0, 0, 0, 0.7)',
											color: 'white',
											textAlign: 'center',
											py: 1,
										},
									},
								},
								// '& .wp-block-gallery': {
								// 	flexBasis: '100%',
								// 	flexWrap: 'wrap',

								// 	'& figure.wp-block-image': {
								// 		overflow: 'hidden',
								// 		borderRadius: '8px',
								// 		position: 'relative',
								// 		flexBasis: '25%',
								// 		p: 0,
								// 		m: 2,
								// 		flexGrow: '1',
								// 		height: '252px',

								// 		'& img': {
								// 			borderRadius: 0,
								// 			height: 'auto!important',
								// 			flexShrink: 0,
								// 		},

								// 		'& figcaption': {
								// 			position: 'absolute',
								// 			bottom: 0,
								// 			width: '100%',
								// 			background: 'rgba(0, 0, 0, 0.7)',
								// 			color: 'white',
								// 			textAlign: 'center',
								// 			py: 2,
								// 		},
								// 	},
								// },
								'& .wp-block-image': {
									flexDirection: 'column',
								},
							})}
							component="div"
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Zone>
				))}

			<Paper
				sx={(theme) => ({
					bgcolor: 'primary.main',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(16, 14),
					backgroundImage: `url(${strips})`,
					backgroundRepeat: 'round no-repeat',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
						backgroundRepeat: 'no-repeat',
					},
				})}
			>
				<img src={chairSun} alt="Le cycle du réemploi solidaire" />
				<Typography
					sx={(theme) => ({
						fontWeight: 800,
						fontSize: 22,
						px: 32,
						mt: 2,
						lineHeight: 1.2,
						[theme.breakpoints.down('md')]: {
							px: 0,
							my: 2,
						},
					})}
				>
					Faites le choix de l’écoresponsable
				</Typography>
				<Typography
					sx={(theme) => ({
						fontWeight: 400,
						fontSize: 18,
						mt: 1,
						px: 10,
						[theme.breakpoints.down('md')]: {
							px: 0,
							my: 2,
						},
					})}
				>
					En ayant recours à notre association, vous contribuez à bâtir une société plus inclusive,
					à faire de l'économie un outil au service de l'emploi pour toutes et tous et à développer
					des activités écologiques sur nos territoires !
				</Typography>
			</Paper>
		</>
	)
}

export default Benefit
